module.exports = __webpack_public_path__ + "media/images/application/template/arrow-up-2b0212dcc984d42e68a326e35bef5cf0.svg";